import React from "react";
import { Form, Row, Col, Typography, Button, Space, Radio } from 'antd';
import { CaretLeftOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const AppStep17 = ({ next, prev, handleFormData, values }) => {
    const delay = ms => new Promise(res => setTimeout(res, ms));
    const submitFormData = async (e) => {
          await delay(500);
        next();
    };
    return(
        <Form 
            name="step17"
            onChange={submitFormData}
        >
            <Title level={2}>Combien d'eau buvez-vous quotidiennement ?</Title>
            <Form.Item 
                name="eau"
                defaultValue={values.eau}
                onChange={handleFormData("eau")}
                rules={[
                    {
                    required: true,
                    message: 'Choisissez s\'il vous plaît!',
                    },
            ]}>
                <section className="typicalday">
                <Radio.Group>
                    <div className="typicaldaydiv">
                        <input type="radio" id="control_01" name="select" value="cafe-the" />
                        <label className="bodytypelbl" htmlFor="control_01">
                                <Text strong>Café ou thé seulement</Text>
                        </label>
                    </div>
                    <div className="typicaldaydiv">
                        <input type="radio" id="control_02" name="select" value="<2-verres" />
                        <label htmlFor="control_02">
                                <Text strong>Moins de 2 verres</Text>
                        </label>
                    </div>
                    <div className="typicaldaydiv">
                        <input type="radio" id="control_03" name="select" value="2-6-verres" />
                        <label htmlFor="control_03">
                                <Text strong>2-6 verres</Text>
                        </label>
                    </div>
                    <div className="typicaldaydiv">
                        <input type="radio" id="control_04" name="select" value="7-10-verres" />
                        <label htmlFor="control_04">
                                <Text strong>7-10 verres</Text>
                        </label>
                    </div>
                    <div className="typicaldaydiv">
                        <input type="radio" id="control_05" name="select" value=">10-verres" />
                        <label htmlFor="control_05">
                                <Text strong>Plus de 10 verres</Text>
                        </label>
                    </div>
                    </Radio.Group>
                </section>
            </Form.Item>

            <Row justify="start">
            <Col xs={{ span: 8 }} sm={{ span: 6 }} md={{ span: 4 }}>
                <Form.Item  className="steps-action">
                <Space style={{ width: '100%' }}>
                    <Button onClick={prev} icon={<CaretLeftOutlined />} />
                    {/* <Button type="primary" htmlType="submit">
                        Continue
                    </Button> */}
                </Space>
                </Form.Item>
            </Col>
            </Row>
        </Form>
    )
}
export default AppStep17;